import React from 'react';
import styled from 'styled-components';
import { minBp, maxBp } from 'src/lib/theme';

export const Wrap = styled.div`
  ${({ accessoriesView, categoryLength }) => `
    padding: ${accessoriesView ? '33px' : '30px'} 30px 90px;
    position: relative;

    @media ${minBp('tablet')} {
      padding: 46px 30px 90px;
      ${categoryLength <= 8 && !accessoriesView ? 'padding: 46px 30px 160px' : ''};
      ${categoryLength <= 4 && !accessoriesView ? 'padding: 46px 30px 300px' : ''};
    }

    @media ${minBp('tabletLarge')} {
      padding: 65px 40px ${accessoriesView ? '100px' : '140px'} 40px;
    }

    @media ${minBp('desktop')} {
      padding: 100px 160px 0px 40px;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  `}
`;

export const Title = styled.h3`
  ${({ mobile, desktop }) => `
    display: ${desktop ? 'none' : 'block'};

    @media ${minBp('tabletLarge')} {
      display: ${desktop ? 'block' : 'none'};
    }
  `}

  text-transform: uppercase;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.dinRegular};
  font-weight: 400;
  line-height: 1.25;
  font-size: 14px;
  width: 170px;
  margin: 0 auto 12px;

  strong {
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    font-weight: 500;
  }

  @media ${minBp('tablet')} {
    width: 250px;
  }

  @media ${minBp('tabletLarge')} {
    font-size: 25px;
    text-align: left;
    margin: 0 0 15px;
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    font-weight: 500;
    width: 100%;
  }

  @media ${minBp('desktop')} {
    font-size: 20px;
    max-width: 300px;
  }
`;

export const Divider = styled.div`
  @media ${minBp('desktop')} {
    background: #c7c7c7;
    height: 1px;
    margin: 20px 0 17px;
  }
`;

export const Filters = styled.div`
  display: none;

  @media ${minBp('desktop')} {
    display: block;
  }
`;

export const VisibilityNotice = styled.div`
  display: none;

  ${({ isInModal }) =>
    isInModal
      ? `
    display: block;
  `
      : ``}

  @media ${minBp('tabletLarge')} {
    font-size: 14px;
    display: block;
    margin-bottom: 10px;
  }

  @media ${minBp('desktop')} {
    margin-bottom: 0;
  }

  svg {
    vertical-align: middle;
    width: 16px;
    margin-right: 3px;

    @media ${minBp('tabletLarge')} {
      width: 20px;
      pointer-events: none;
    }

    path {
      fill: #7a7a7a;
    }
  }
`;

export const AccessoriesTitleBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 30px;
  background: white;
  text-transform: uppercase;
  height: 60px;
  display: flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  color: black;
  font-weight: 500;
  cursor: pointer;

  @media ${minBp('tabletLarge')} {
    display: none;
  }
`;

export const BackButton = styled.div`
  padding: 4px 10px;
  margin-left: -10px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  top: -2px;
  pointer-events: none;

  svg {
    vertical-align: middle;
    width: 16px;
    height: 16px;
  }

  @media ${minBp('tablet')} {
    svg {
      width: 20px;
      height: 20px;
    }
  }

  @media ${minBp('tabletLarge')} {
    top: -3px;
    pointer-events: auto;
    cursor: pointer;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media ${minBp('desktop')} {
    display: none;
  }
`;

export const BikeModel = styled.span`
  white-space: nowrap;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
`;

export const SearchWrapper = styled.div`
  margin-bottom: 10px;

  @media ${minBp('tabletLarge')} {
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }
`;

export const SearchInputWrapper = styled.div`
  background: white;
  border: 1px solid #000;
  position: relative;
  flex: 1;

  svg {
    position: absolute;
    width: 16px;
    height: 16px;
    top: 9px;
    right: 10px;
  }

  @media ${minBp('tabletLarge')} {
    max-width: 500px;

    svg {
      width: 20px;
      height: 20px;
      top: 12px;
      right: 12px;
    }
  }
`;

export const SearchInput = styled.input`
  appearance: none;
  font-family: inherit;
  font-size: 16px;
  padding: 3px 35px 0 15px;
  height: 34px;
  display: flex;
  align-items: center;
  border: 0;
  width: 100%;

  @media ${minBp('tabletLarge')} {
    height: 42px;
  }
`;

export const SearchClearButton = styled.button`
  display: none;

  @media ${minBp('tabletLarge')} {
    display: block;
    appearance: none;
    border: 0;
    border-radius: 0;
    height: 32px;
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    font-size: 12px;
    text-transform: uppercase;
    margin-left: 16px;
    padding-top: 5px;
    min-width: 90px;
    background-color: black;
    color: white;

    &:disabled {
      background-color: white;
      color: black;
    }
  }
`;

export const FilterResultsWrapper = styled.div`
  display: flex;
  margin-bottom: 14px;

  @media ${minBp('tabletLarge')} and ${maxBp('desktop')} {
    position: relative;
  }
`;

export const SelectWrap = styled.div`
  ${({ category, sort }) => `
    border: 1px solid #000;
    position: relative;
    margin-right: 4px;
    flex: 1;
    min-width: calc(50% - 4px);
    background-color: white;

    &:last-of-type {
      margin-right: 0;
      margin-left: 4px;
    }

    svg {
      position: absolute;
      top: 10px;
      right: 8px;
      width: 16px;
      height: 16px;
      pointer-events: none;
    }

    @media ${minBp('tabletLarge')} {
      min-width: 140px;
      flex: none;
      margin-left: 20px;

      svg {
        top: 10px;
      }

      ${
        category
          ? `
        display: none;
      `
          : ``
      }

      ${
        sort
          ? `
        position: absolute;
        bottom: 0;
        right: 0;
        min-width: 90px;
        background-color: transparent;

        svg {
          top: 10px;
        }

        &:last-of-type {
          margin-left: 0;
        }
      `
          : ``
      }
    }

    @media ${minBp('desktop')} {
      ${
        sort
          ? `
        top: 50px;
        right: 120px;
        bottom: inherit;
      `
          : ``
      }
    }
  `}
`;

export const Select = styled.select`
  appearance: none;
  border: 0;
  border-radius: 0;
  padding: 8px 35px 8px 15px;
  color: #000;
  background: transparent;
  width: 100%;
  text-align: left;
  font-family: inherit;
  font-size: 16px;
  height: 34px;

  @media ${minBp('tabletLarge')} {
    font-size: 14px;
    padding: 8px 30px 8px 15px;
    height: 42px;
  }

  @media ${minBp('desktop')} {
    height: 34px;
  }
`;

export const VisibilityModal = styled.div`
  padding: 20px;
  font-size: 16px;
  line-height: 1;
`;

export const Disclaimer = styled.p`
  text-align: left;
  font-size: 12px;
  line-height: 1.5;
  color: #000;
`;
